const routes = [{
  path: '/controlManage',  //布控管理
  name: 'controlManage',
  component: () => import('./view/Main.vue'),
  redirect: '/controlManage/task',
  meta: {
    requireAuth: false
  },
  children: [{
    path: 'task',//信息布控
    name: 'task',
    component: () => import('./view/manage.vue'),
    meta: {
      // requireAuth: false,
      // routerAlive: true
    }
  }, {
    path: 'record',//布控记录
    name: 'record',
    component: () => import('./view/record.vue'),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  }, {
    path: 'cartask',//车辆布控
    name: 'cartask',
    component: () => import('./view/carManage.vue'),
    meta: {
      // requireAuth: false,
      // routerAlive: true
    }
  }]
}]

export default routes
